export enum PhaseTypeEnum {
  Materials = 'Materials',
  Garage = 'Garage',
  Hanging = 'Hanging',
  Finishing = 'Finishing',
  Spraying = 'Spraying',
  Bump1 = 'Bump1',
  Bump2 = 'Bump2',
  Bump3 = 'Bump3',
  Bump4 = 'Bump4',
  Bump5 = 'Bump5',

  Hang = 'Hang',
  Finish = 'Finish',
  Prime = 'Prime',
  DrywallTouchUp1 = 'DrywallTouchUp1',
  Trim1 = 'Trim1',
  InteriorPaint = 'InteriorPaint',
  DrywallTouchUp2 = 'DrywallTouchUp2',
  Trim2 = 'Trim2',
  FinalPaint = 'FinalPaint',
  DrywallTouchUp3 = 'DrywallTouchUp3',
  CMBluetape = 'CMBluetape',
  FinalBluetape = 'FinalBluetape',
}
